#import "../../../graphql/fragments/engagement-stats-fragment.graphql"
#import "../../../sms/engagement/graphql/fragments/sms-edition-engagement-stats-fragment.graphql"

fragment AudienceEngagementStats on Audience {
    id
    engagementStats {
        ...EngagementStats
    }
    smsEngagementStats {
        ...SmsEditionEngagementStatsFragment
    }
}
